import { render, staticRenderFns } from "./Crew.vue?vue&type=template&id=40f4633a&scoped=true&"
import script from "./Crew.vue?vue&type=script&lang=js&"
export * from "./Crew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f4633a",
  null
  
)

export default component.exports